import React, { Component } from 'react'
import Loader from '../../../../Components/Loader';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { Colors } from '../../../../Styles/Colors'
import { CommonPatientCard, CommonPatientDetails, DeletePopup } from '../../../../Components/Common Components/CommonComponents'
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { Autocomplete, Box, Button, Chip, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { Alcohol_List, Daily_Activity_List, Drug_List, Smoking_List, Yes_Or_No, Diet_Type_List, Mental_Status_List } from '../../../../Utility/Constants';
import { getCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { CheckAccessFunc } from "../../../../Components/CommonFunctions/CommonFunctions";
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';

export default class DocSocialHistory extends Component {

  constructor(props) {
    super(props)
    this.state = {
      socialHistoryData: [],
      alcoholList: Alcohol_List,
      dietTypeList: Diet_Type_List,
      mentalStatusList: Mental_Status_List,
      fluidIntake: '',
      stepsCount: '',
      caloriesBurned: '',
      sleepDuration: '',
      generalWellBeing: '',
      smokingList: Smoking_List,
      dailyActivityList: Daily_Activity_List,
      yesOrNo: Yes_Or_No,
      drugList: Drug_List,
      selectedAlcohol: '',
      selectedDietType: '',
      selectedMentalStatus: '',
      hasAbha: localGetItem("has_abha_service") === 'true' ? true : false,
      alcoholComment: '',
      selectedDailyActivity: '',
      dailyActivityComment: '',
      selectedExercise: '',
      exerciseComment: '',
      selectedMarried: '',
      marriedComment: '',
      selectedSmoking: '',
      smokingComment: '',
      selectedDrugs: [],
      occupation: '',
      selectedId: null,
      deletePopUp: false,
      isEdit: false,
      patientDetails: {},
      clinicId: '',
      appointmentId: '',
      patientId: '',
      newEnterDrug: null,
      // for fo 
      withOutAppointment: {},
      doctor_id: "",
      selectedTobacco: '',
      tobaccoComments: '',
    }
  }

  componentDidMount() {
    let clinicId = getCachevalue('SelectedDoctorClinic')
    let appointmentId = JSON.parse(getCachevalue('DoctorPatientData'))
    let ipPatientData = JSON.parse(getCachevalue("IppatientData"));
    let appointmentDetail = JSON.parse(getCachevalue("withoutAppointment"));
    const newState = {
      clinicId: clinicId,
      appointmentId: appointmentId?.appointment_id,
      patientId: appointmentId?.patient_id || ipPatientData?.patient_id,
      doctor_id: ipPatientData?.doctor_id,
      patientDetails: ipPatientData || appointmentId,
    };
    if (appointmentDetail?.patient_id === ipPatientData?.patient_id) {
      newState.withOutAppointment = appointmentDetail;
    }
    this.setState({
      ...newState
    }, () => {
      if(!this.props.is_From_Fo){
      this.getPatientDetailData()
      }
      this.getSocialHistoryData()
    })

  }

  getPatientDetailData = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + this.state.patientId)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              patientDetails: {...this.state.patientDetails, ...response?.data?.data}
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getSocialHistoryData = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_SOCIAL_HISTORY + '?patient_id=' + this.state.patientId)
        .then((response) => {
          if (response?.data?.status === 'success') {
            let list = response?.data?.data
            if(list?.length > 0){
            this.setState({
              socialHistoryData: response?.data?.data,
              selectedAlcohol: list[0]?.alcohol,
              fluidIntake: list[0]?.fluid_intake,
              stepsCount: list[0]?.steps_count,
              caloriesBurned: list[0]?.calories_burned,
              sleepDuration: list[0]?.sleep_duration,
              generalWellBeing: list[0]?.general_well_being,
              selectedDietType: list[0]?.diet_type,
              selectedMentalStatus: list[0]?.mental_status,
              alcoholComment: list[0]?.alcohol_comments || '',
              selectedDailyActivity: list[0]?.daily_activity,
              dailyActivityComment: list[0]?.daily_activity_comments || '',
              selectedSmoking: list[0]?.smoking,
              smokingComment: list[0]?.smoking_comments || '',
              selectedDrugs: list[0]?.drugs[0]?.includes(',') ? list[0]?.drugs[0]?.split(',') : list[0]?.drugs?.map((item) => item),
              selectedExercise: list[0]?.is_exercise_done_daily === null ? '' : list[0]?.is_exercise_done_daily ? 'Yes' : 'No',
              exerciseComment: list[0]?.exercise_comments || '',
              selectedMarried: list[0]?.is_married === null ? '' : list[0]?.is_married ? 'Yes' : 'No',
              marriedComment: list[0]?.is_married_comments || '',
              selectedId: list[0]?.id,
              occupation: list[0]?.occupation,
              isEdit: true,
              selectedTobacco: list[0]?.tobacco_chewing === null ? '' : list[0]?.tobacco_chewing ? 'Yes' : 'No',
              tobaccoComments: list[0]?.tobacco_chewing_comments || '',
            })
          }
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  postSocialHistoryData = () => {
    try {
      let data = {
        alcohol: this.state.selectedAlcohol,
        alcohol_comments: this.state.alcoholComment,
        fluid_intake: this.state.fluidIntake,
        steps_count: this.state.stepsCount,
        calories_burned: this.state.caloriesBurned,
        sleep_duration: this.state.sleepDuration,
        general_well_being: this.state.generalWellBeing,
        diet_type: this.state.selectedDietType,
        mental_status: this.state.selectedMentalStatus,
        appointment_id: this.state.appointmentId,
        daily_activity: this.state.selectedDailyActivity,
        daily_activity_comments: this.state.dailyActivityComment,
        drugs: this.state.selectedDrugs,
        is_exercise_done_daily: this.state.selectedExercise === '' ? null : this.state.selectedExercise === 'Yes' ? true : false,
        exercise_comments: this.state.exerciseComment,
        is_married: this.state.selectedMarried === '' ? null : this.state.selectedMarried === 'Yes' ? true : false,
        is_married_comments: this.state.marriedComment,
        occupation: this.state.occupation,
        patient_id: this.state.patientId,
        smoking: this.state.selectedSmoking,
        smoking_comments: this.state.smokingComment,
        id: this.state.selectedId ? this.state.selectedId : null,
        tobacco_chewing: this.state.selectedTobacco === '' ? null : this.state.selectedTobacco === 'Yes' ? true : false,
        tobacco_chewing_comments: this.state.tobaccoComments,
      }
      if(this.props.is_From_Fo){
        data['doctor_id'] = this.state.doctor_id
      }
      this.LoaderFunction(true)
      RestAPIService.create(data, Serviceurls.DOC_SOCIAL_HISTORY)
        .then((response) => {
          if (response.data.status === 'success') {
            this.LoaderFunction(false)
            this.successMessage(response.data.message)
            this.getSocialHistoryData()
            this.onClearSocialHistory()
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.LoaderFunction(false)
            this.errorMessage(error.response.data.message)
          } else {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.LoaderFunction(false)
      this.errorMessage(error.message)
    }
  }

  deleteSocialHistoryData = () => {
    try {
      let data = {
        'patient_id': this.state.patientId,
        'id': this.state.selectedId
      }
      this.setState({ removeData: true })
      this.LoaderFunction(true)
      RestAPIService.delete(Serviceurls.DOC_SOCIAL_HISTORY, data)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({ removeData: false })
            this.LoaderFunction(false)
            this.successMessage(response.data.message)
            this.getSocialHistoryData()
            this.onClearSocialHistory()
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ removeData: false })
            this.LoaderFunction(false)
            this.errorMessage(error.response.data.message)
          } else {
            this.setState({ removeData: false })
            this.LoaderFunction(false)
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ removeData: false })
      this.LoaderFunction(false)
      this.errorMessage(error.message)
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  checkMandatory = () => {
    try {
      let validate = false;
      if ((this.state.selectedAlcohol === '') && (this.state.selectedDailyActivity === '') && (this.state.selectedDrugs.length === 0)
        && (this.state.selectedExercise === '') && (this.state.selectedMarried === '') && (this.state.selectedSmoking === '') && (this.state.occupation === '')) {
        validate = true
      }
      //  else if (this.state.selectedAlcohol === '') {
      //   validate = true
      // } else if (this.state.selectedDailyActivity === '') {
      //   validate = true
      // } else if (this.state.selectedDrugs?.length < 0) {
      //   validate = true
      // } else if (this.state.selectedExercise === '') {
      //   validate = true
      // } else if (this.state.selectedMarried === '') {
      //   validate = true
      // }

      return validate;
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  popupClose = () => {
    try {
      this.setState({
        deletePopUp: false
      })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  onClearSocialHistory = () => {
    try {
      this.setState({
        selectedAlcohol: '',
        alcoholComment: '',
        fluidIntake: '',
        stepsCount: '',
        caloriesBurned: '',
        sleepDuration: '',
        generalWellBeing: '',
        selectedDietType: '',
        selectedMentalStatus: '',
        selectedDailyActivity: '',
        dailyActivityComment: '',
        selectedExercise: '',
        exerciseComment: '',
        selectedMarried: '',
        marriedComment: '',
        selectedSmoking: '',
        smokingComment: '',
        selectedDrugs: [],
        occupation: '',
        selectedId: null,
        isEdit: false,
        deletePopUp: false,
        newEnterDrug: null,
        selectedTobacco: '',
        tobaccoComments: '',
      })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
  renderRightSide = () => {
    const enableAdd = this.checkMandatory();
    const checkuserAccess = (CheckAccessFunc("front_office", "In Patients", "History", "Social History", "SubTab")?.editAccess ?
    this.state.withOutAppointment?.is_ip || true && !enableAdd : !enableAdd);
    try {
      return (
        <Box component={'div'} width={'92.5vw'}>
          <Box component={'div'} height={'2vw'} display={'flex'} pl={'0.5vw'} alignItems={'center'}>
            <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Social History</Typography>
          </Box>
          <Box component={'div'} height={'23vw'} sx={{ backgroundColor: Colors.white }} overflow={'scroll'}>
            <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
              <Box component={'div'} pl={'0.5vw'} width={'25vw'}>
                <Box component={'div'} height={'2vw'} display={'flex'} alignItems={'center'} mr={'1vw'}>
                  <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Alcohol</Typography>
                </Box>
                <Box>
                  {this.state.alcoholList?.map((item, index) => (
                    <Chip
                      className={`eMed_chip ${item.label === this.state.selectedAlcohol ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                      size='small'
                      label={item.label}
                      disabled={this.state.isEdit}
                      variant={item.label === this.state.selectedAlcohol ? 'contained' : 'outlined'}
                      key={index}
                      onClick={() => {
                        if (item.label === this.state.selectedAlcohol) {
                          this.setState({ selectedAlcohol: '' })
                        } else {
                          this.setState({ selectedAlcohol: item?.value })
                        }
                      }}
                      // color={'primary'}
                      clickable
                    />
                  ))}
                </Box>
                <TextField
                  fullWidth
                  size="small"
                  label="Comments"
                  sx={{ mt: 0.5, width: '20vw' }}
                  InputProps={{ readOnly: this.state.isEdit || !this.state.selectedAlcohol }}
                  value={this.state.alcoholComment}
                  onChange={(e) => {
                    if (e.target.value.length <= 250) {
                      this.setState({ alcoholComment: e.target.value });
                    } else {
                      this.errorMessage('Allowed only 250 characters');
                    }
                  }}
                />
              </Box>
              <Box component={'div'} pl={'0.5vw'} width={'25vw'}>
                <Box component={'div'} height={'2vw'} display={'flex'} alignItems={'center'} mr={'1vw'}>
                  <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Smoking</Typography>
                </Box>
                <Box>
                  {this.state.smokingList?.map((item, index) => (
                    <Chip
                      className={`eMed_chip ${item.label === this.state.selectedSmoking ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                      size='small'
                      label={item.label}                      
                      disabled={this.state.isEdit}
                      variant={item.label === this.state.selectedSmoking ? 'contained' : 'outlined'}
                      key={index}
                      onClick={() => {
                        if (item.label === this.state.selectedSmoking) {
                          this.setState({ selectedSmoking: '' })
                        } else {
                          this.setState({ selectedSmoking: item?.value })
                        }
                      }}
                      // color={'primary'}
                      clickable
                    />
                  ))}
                </Box>
                <TextField
                  fullWidth
                  size="small"
                  label="Comments"
                  sx={{ mt: 0.5, width: '20vw' }}
                  InputProps={{ readOnly: this.state.isEdit || !this.state.selectedSmoking }}
                  value={this.state.smokingComment}
                  onChange={(e) => {
                    if (e.target.value.length <= 250) {
                      this.setState({ smokingComment: e.target.value });
                    } else {
                      this.errorMessage('Allowed only 250 characters');
                    }
                  }}
                /> 
              </Box>
              <Box component={'div'} pl={'0.5vw'} width={'25vw'}>
                <Box component={'div'} height={'2vw'} display={'flex'} alignItems={'center'} mr={'1vw'}>
                  <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Drugs</Typography>
                </Box>
                <Box>
                  <Autocomplete
                    clearIcon
                    size='small'
                    multiple
                    freeSolo                    
                    readOnly={this.state.isEdit}
                    sx={{ width: '20vw', mb: '0.5vw' }}
                    options={this.state.drugList?.map((item) => item?.label)}
                    // getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.label}
                    value={this.state.selectedDrugs}
                    limitTags={3}
                    autoComplete='off'
                    onChange={(event, newValue) => {
                      this.setState({
                        selectedDrugs: newValue
                      })
                    }}
                    renderTags={(value, getTagProps) => (
                      value?.map((option, index) => (<Chip variant="outlined" size='small' label={option} {...getTagProps({ index })} />))
                    )}
                    renderInput={(params) => <TextField {...params} label='Select Problems'
                    />}
                  />
                </Box>
              </Box>
            </Box>
            <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} mt={'2vw'}>
              <Box component={'div'} pl={'0.5vw'} width={'25vw'}>
                <Box component={'div'} height={'2vw'} display={'flex'} alignItems={'center'} mr={'1vw'}>
                  <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Rate Your Daily Activity</Typography>
                </Box>
                <Box>
                  {this.state.dailyActivityList?.map((item, index) => (
                    <Chip
                      className={`eMed_chip ${item.label === this.state.selectedDailyActivity ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                      size='small'
                      label={item.label}                      
                      disabled={this.state.isEdit}
                      variant={item.label === this.state.selectedDailyActivity ? 'contained' : 'outlined'}
                      key={index}
                      onClick={() => {
                        if (item.label === this.state.selectedDailyActivity) {
                          this.setState({ selectedDailyActivity: '' })
                        } else {
                          this.setState({ selectedDailyActivity: item?.value })
                        }
                      }}
                      // color={'primary'}
                      clickable
                    />
                  ))}
                </Box>
                <TextField
                  fullWidth
                  size="small"
                  label="Comments"
                  sx={{ mt: 0.5, width: '20vw' }}
                  InputProps={{ readOnly: this.state.isEdit || !this.state.selectedDailyActivity }}
                  value={this.state.dailyActivityComment}
                  onChange={(e) => {
                    if (e.target.value.length <= 250) {
                      this.setState({ dailyActivityComment: e.target.value });
                    } else {
                      this.errorMessage('Allowed only 250 characters');
                    }
                  }}
                />
              </Box>
              <Box component={'div'} pl={'0.5vw'} width={'25vw'}>
                <Box component={'div'} height={'2vw'} display={'flex'} alignItems={'center'} mr={'1vw'}>
                  <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Is Married</Typography>
                </Box>
                <Box>
                  {this.state.yesOrNo?.map((item, index) => (
                    <Chip
                      className={`eMed_chip ${item.label === this.state.selectedMarried ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                      size='small'
                      disabled={this.state.isEdit}
                      label={item.label}
                      variant={item.label === this.state.selectedMarried ? 'contained' : 'outlined'}
                      key={index}
                      onClick={() => {
                        if (item.label === this.state.selectedMarried) {
                          this.setState({ selectedMarried: '' })
                        } else {
                          this.setState({ selectedMarried: item?.value })
                        }
                      }}
                      // color={'primary'}
                      clickable
                    />
                  ))}
                </Box>
                <TextField
                  fullWidth
                  size="small"
                  label="Comments"
                  sx={{ mt: 0.5, width: '20vw' }}
                  InputProps={{ readOnly: this.state.isEdit || !this.state.selectedMarried }}
                  value={this.state.marriedComment}
                  onChange={(e) => {
                    if (e.target.value.length <= 250) {
                      this.setState({ marriedComment: e.target.value });
                    } else {
                      this.errorMessage('Allowed only 250 characters');
                    }
                  }}
                />
              </Box>
              <Box component={'div'} pl={'0.5vw'} width={'25vw'}>
                <Box component={'div'} height={'2vw'} display={'flex'} alignItems={'center'} mr={'1vw'}>
                  <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Do You Exercise ?</Typography>
                </Box>
                <Box>
                  {this.state.yesOrNo?.map((item, index) => (
                    <Chip
                      className={`eMed_chip ${item.label === this.state.selectedExercise ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                      size='small'
                      label={item.label}
                      disabled={this.state.isEdit}
                      variant={item.label === this.state.selectedExercise ? 'contained' : 'outlined'}
                      key={index}
                      onClick={() => {
                        if (item.label === this.state.selectedExercise) {
                          this.setState({ selectedExercise: '' })
                        } else {
                          this.setState({ selectedExercise: item?.value })
                        }
                      }}
                      // color={'primary'}
                      clickable
                    />
                  ))}
                </Box>
                <TextField
                  fullWidth
                  size="small"
                  label="Comments"
                  sx={{ mt: 0.5, width: '20vw' }}
                  InputProps={{ readOnly: this.state.isEdit || !this.state.selectedExercise }}
                  value={this.state.exerciseComment}
                  onChange={(e) => {
                    if (e.target.value.length <= 250) {
                      this.setState({ exerciseComment: e.target.value });
                    } else {
                      this.errorMessage('Allowed only 250 characters');
                    }
                  }}
                />
              </Box>
            </Box>
            {/* Occupation and Tobacco Chewing side by side */}
          <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} mt={'2vw'}>
            {/* Occupation Field */}
            <Box component={'div'} pl={'0.5vw'} width={'25vw'}>
              <Box height="2vw" display="flex" alignItems="center" mr="1vw">
                <Typography fontSize="0.9vw" fontWeight={600} color={Colors.SecondaryText}>
                  Occupation
                </Typography>
              </Box>
              <TextField
                sx={{ width: '30vw' }}
                label="Occupation"
                multiline
                rows={3}
                value={this.state.occupation}
                InputProps={{ readOnly: this.state.isEdit }}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value?.length <= 250 || value === '') {
                    this.setState({ occupation: value });
                  } else {
                    this.errorMessage('Allowed only 250 characters');
                  }
                }}
              />
            </Box>

            {/* Tobacco Chewing */}
            <Box component={'div'} pl={'0.5vw'} width={'25vw'}>
              <Box height="2vw" display="flex" alignItems="center" mr="1vw">
                <Typography fontSize="0.9vw" fontWeight={600} color={Colors.SecondaryText}>
                  Tobacco Chewing
                </Typography>
              </Box>
              <Box display="flex"  mb="0.5vw">
                {this.state.yesOrNo?.map((item, index) => (
                  <Chip
                    key={index}
                    size="small"
                    className={`eMed_chip ${item.label === this.state.selectedTobacco ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                    label={item.label}
                    disabled={this.state.isEdit}
                    variant={item.label === this.state.selectedTobacco ? 'contained' : 'outlined'}
                    onClick={() => {
                      this.setState({
                        selectedTobacco:
                          item.label === this.state.selectedTobacco ? '' : item.value
                      });
                    }}
                    clickable
                  />
                ))}
              </Box>
              <TextField
                fullWidth
                size="small"
                label="Comments"
                sx={{ mt: 0.5, width: '20vw' }}
                value={this.state.tobaccoComments}
                InputProps={{ readOnly: this.state.isEdit || !this.state.selectedTobacco }}
                onChange={(e) => {
                  if (e.target.value.length <= 250) {
                    this.setState({ tobaccoComments: e.target.value });
                  } else {
                    this.errorMessage('Allowed only 250 characters');
                  }
                }}
              />
            </Box>
            {this.state.hasAbha ? (
            <Box component={'div'} pl={'0.5vw'} width={'25vw'}>
                <Box component={'div'} height={'2vw'} display={'flex'} alignItems={'center'} mr={'1vw'}>
                  <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Fluid Intake (litre/day)</Typography>
                </Box>
                <TextField
                  fullWidth
                  size="small"
                  label="Enter Fluid Intake"
                  sx={{ mt: 0.5, width: '20vw' }}
                  value={this.state.fluidIntake}
                  onChange={(e) => {
                    if (CommonValidation.numberOnly(e.target.value) || e.target.value === '') {
                      this.setState({ fluidIntake: e.target.value });
                    }
                  }}
                />
            </Box>
            ) : <Box component={'div'} pl={'0.5vw'} width={'25vw'}></Box>}
          </Box>
          {this.state.hasAbha ? (
          <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} mt={'2vw'}>
            <Box component={'div'} pl={'0.5vw'} width={'25vw'}>
              <Box height="2vw" display="flex" alignItems="center" mr="1vw">
                <Typography fontSize="0.9vw" fontWeight={600} color={Colors.SecondaryText}>
                  Daily Steps Count (steps/day)
                </Typography>
              </Box>
            <TextField
              fullWidth
              size="small"
              label="Enter Steps Count"
              sx={{ mt: 0.5, width: '20vw' }}
              value={this.state.stepsCount}
              onChange={(e) => {
                if (CommonValidation.numberOnly(e.target.value) || e.target.value === '') {
                  this.setState({ stepsCount: e.target.value });
                }
              }}
            />
            </Box>
            <Box component={'div'} pl={'0.5vw'} width={'25vw'}>
              <Box height="2vw" display="flex" alignItems="center" mr="1vw">
                <Typography fontSize="0.9vw" fontWeight={600} color={Colors.SecondaryText}>
                  Calories Burned (kcal/day)
                </Typography>
              </Box>
              <TextField
                fullWidth
                size="small"
                label="Enter calories burned"
                sx={{ mt: 0.5, width: '20vw' }}
                value={this.state.caloriesBurned}
                onChange={(e) => {
                  if (CommonValidation.numberOnly(e.target.value) || e.target.value === '') {
                    this.setState({ caloriesBurned: e.target.value });
                  }
                }}
              />
            </Box>
            <Box component={'div'} pl={'0.5vw'} width={'25vw'}>
              <Box height="2vw" display="flex" alignItems="center" mr="1vw">
                <Typography fontSize="0.9vw" fontWeight={600} color={Colors.SecondaryText}>
                  Sleep Duration (hrs/day)
                </Typography>
              </Box>
              <TextField
                fullWidth
                size="small"
                label="Enter sleep duration"
                sx={{ mt: 0.5, width: '20vw' }}
                value={this.state.sleepDuration}
                onChange={(e) => {
                  if (CommonValidation.numberOnly(e.target.value) || e.target.value === '' || parseInt(e.target.value) <= 24) {
                    this.setState({ sleepDuration: e.target.value });
                  }
                }}
              />
            </Box>
          </Box>
          ) : null}
          {this.state.hasAbha ? (
          <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} mt={'2vw'}>
            <Box component={'div'} pl={'0.5vw'} width={'25vw'}>
              <Box height="2vw" display="flex" alignItems="center" mr="1vw">
                <Typography fontSize="0.9vw" fontWeight={600} color={Colors.SecondaryText}>
                  Diet Type
                </Typography>
              </Box>
              <Box>
                {this.state.dietTypeList?.map((item, index) => (
                  <Chip
                    className={`eMed_chip ${item.label === this.state.selectedDietType ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                    size='small'
                    label={item.label}
                    disabled={this.state.isEdit}
                    variant={item.label === this.state.selectedDietType ? 'contained' : 'outlined'}
                    key={index}
                    onClick={() => {
                      if (item.label === this.state.selectedDietType) {
                        this.setState({ selectedDietType: '' })
                      } else {
                        this.setState({ selectedDietType: item?.value })
                      }
                    }}
                    // color={'primary'}
                    clickable
                  />
                ))}
              </Box>
            </Box>
            <Box component={'div'} pl={'0.5vw'} width={'25vw'}>
              <Box height="2vw" display="flex" alignItems="center" mr="1vw">
                <Typography fontSize="0.9vw" fontWeight={600} color={Colors.SecondaryText}>
                  Mental Status
                </Typography>
              </Box>
              <Box>
                {this.state.mentalStatusList?.map((item, index) => (
                  <Chip
                    className={`eMed_chip ${item.label === this.state.selectedMentalStatus ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                    size='small'
                    label={item.label}
                    disabled={this.state.isEdit}
                    variant={item.label === this.state.selectedMentalStatus ? 'contained' : 'outlined'}
                    key={index}
                    onClick={() => {
                      if (item.label === this.state.selectedMentalStatus) {
                        this.setState({ selectedMentalStatus: '' })
                      } else {
                        this.setState({ selectedMentalStatus: item?.value })
                      }
                    }}
                    // color={'primary'}
                    clickable
                  />
                ))}
              </Box>
            </Box>
            <Box component={'div'} pl={'0.5vw'} width={'25vw'}>
            <Box height="2vw" display="flex" alignItems="center" mr="1vw">
                <Typography fontSize="0.9vw" fontWeight={600} color={Colors.SecondaryText}>
                  General Well Being
                </Typography>
              </Box>
              <TextField
                fullWidth
                size="small"
                label="Enter comments"
                sx={{ mt: 0.5, width: '20vw' }}
                value={this.state.generalWellBeing}
                onChange={(e) => {
                    this.setState({ generalWellBeing: e.target.value });
                }}
              />
            </Box>
          </Box>
          ) : null}
            


          </Box>
          <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'3vw'}>
            {this.state.socialHistoryData?.length > 0 ? null : <Button
              sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize', mr: '1vw' }}
              variant='outlined'
              onClick={() => {
                this.onClearSocialHistory()
              }}
            >Clear</Button>}
            {this.state.isEdit ? <Button
              sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
              variant='contained'
              onClick={() => this.setState({isEdit: false})}
            >Edit</Button> :
             <Button
              sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
              variant='contained'
              disabled={this.props.is_From_Fo ? !checkuserAccess : enableAdd || getCachevalue('DoctorUserChanged') === 'true'}
              onClick={() => this.postSocialHistoryData()}
            >Add</Button>}
          </Box>
        </Box>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  render() {
    let attender = {
      lineOne: "Attender Name",
      lineTwo: `${this.state.patientDetails?.attender_name ? this.state.patientDetails?.attender_name :
        this.state.patientDetails?.caretaker_name ? this.state.patientDetails?.caretaker_name : "-"}`,
      lineFour: 'Contact Number',
      LineFive: `${this.state.patientDetails?.attender_mobile ? this.state.patientDetails?.attender_mobile :
        this.state.patientDetails?.caretaker_mobile ? this.state.patientDetails?.caretaker_mobile : "-"}`
    }
    return (
      <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'74vh'} p={'0.5vw'}>
        <Box component={'div'} display={'flex'}>
          <Box component={'div'} className='doc_header_card' mr={'0.5vw'}>
            <CommonPatientDetails data={this.state.patientDetails} showDetailed={true} fromDoctor={(this.props.is_From_Ip_AdmissionDetails || this.props.is_From_Fo )? false : true} />
          </Box>
          {/* <CommonPatientCard details={attender} showDetailed={true} /> */}
        </Box>
        <Box component={'div'} display={'flex'} mt={'0.5vw'} height={'61.5vh'}>
          <Box component={'div'} flex={0.35} border={'1px solid lightgray'}>
            {this.renderRightSide()}
          </Box>
        </Box>
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.deletePopUp ? <DeletePopup
          DeletTitle={`Are you sure you want to delete ?`}
          deleteAlertPopupClose={this.popupClose.bind(this)}
          removeData={this.deleteSocialHistoryData.bind(this)}
          disabled={this.state.removeData}
        /> : null}
        <Loader loaderOpen={this.state.isLoader} />
      </Box>
    )
  }
}
